













































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import PageBase from '@/views/page/PageBase'
import PageForm from '@/components/PageForm.vue'
import { Pages } from '@/models/Pages'
import { Page } from '@/models/Page'
import Table from '@/components/Table.vue'
import CardTable from '@/components/CardTable.vue'
import Confirm from '@/components/Confirm.vue'
import Modal from '@/components/Modal.vue'

interface SinglePageEdit {
	name: string,
	page: Page,
}

@Component({
	components: {
		PageForm,
		Table,
		CardTable,
		Confirm,
		Modal,
	},
})
export default class PagesView extends PageBase {
	private headers: object[] = [
		{ main: 1, label: 'URL Name', name: 'name' },
		{ main: 1, label: 'Parent', name: 'parent' },
		{ main: 1, label: 'Label', name: 'label' },
	]
	private singleItemEdit: SinglePageEdit = { name: '', page: new Page() }
	private showEdit: boolean = false

	get tableView() {
		return this.$store.getters.tableView
	}

	get rows() {
		const rows = this.pages.models.map((page) => {
			return {
				id: page.id,
				name: page.name,
				parent: this.pageParentStringValue(page.parent),
				label: page.label,
			}
		})
		return rows
	}

	private editPage(id: string) {
		this.$router.push({ name: 'edit-page', params: { id } })
	}

	private confirmDelete(id: number) {
		const confirm = this.$refs.confirm as Confirm
		const deleteItem = this.pages.models.find((item: Page) => item.id === id)
		confirm.create(`This will permanently delete the page.`).then(() => {
			this.$store.dispatch('deletePage', deleteItem)
				.then(() => this.$toasted.success('Page deleted successfully'),
				(error: any) => this.$toasted.error(`Failed to delete page`))
		})
	}

	private editSingle(id: number, name: string) {
		const editArray = this.pages.models.filter((item: any) => item.id === id)
		this.singleItemEdit.page = editArray[0] || null
		this.singleItemEdit.name = name
		this.showEdit = true
	}

	private resetSingleItemEdit() {
		if (this.singleItemEdit.page) {
			this.singleItemEdit.page.reset()
		}
	}

	private updateSingleItem(page: Page) {
		page.save().then(() => {
			this.$toasted.success('Item updated.')
			this.showEdit = false
		}, (error: any) => {
			this.$toasted.error(`Error: ${page.errorArray}`)
			// Reset data
			page.reset()
		})
	}
}
